import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
const SidebarBackdrop = ({ onClick = noop, makeBackdropVisible = false, className = '' }) => {
    const backdropClassNames = classNames('SidebarBackdrop', makeBackdropVisible && 'sidebar-backdrop-bg', className);
    return _jsx("div", { className: backdropClassNames, onClick: onClick, "data-testid": 'sidebarBackdrop' });
};
export default SidebarBackdrop;
